import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { STATES } from 'src/app/models/constdata';
import { ToastrService } from 'ngx-toastr';

import { BehaviorSubject, Observable } from "rxjs";

import { AzureAuthService } from 'src/service/azure-auth.service';
import { CustomerService, DataBusService } from 'src/api/services';
import { UserProfileModel, DataBusLicense, DatabusLicenseFile, Customer, DataBusStatus, CustomerSummary } from 'src/api/models';
import { LicenseStatus } from 'src/app/models/navigation';

import { DataBusTableService } from 'src/service/databus.service';
import { ApplicationConfigService } from 'src/service/application-config.service';
import { Router } from '@angular/router';

interface CustomerForm {
  company: string;
  telephone: string;
  street: string;
  city: string;
  state: string;
}

class LicenseForm {
  licenseId: number;
  serverToken: string;
}

@Component({
  providers: [DataBusService],
  selector: 'app-databus-overview',
  templateUrl: './databus-overview.component.html',
  styleUrls: ['./databus-overview.component.css']
})
export class DatabusOverviewComponent implements OnInit {
  @ViewChild("licenseForm", { static: false }) licenseForm: ModalDirective;

  public remoteData: Observable<any[]>;

  licenses: DataBusLicense[];
  //customers: Customer[];
  //customerId: number;
  isOpen = false;
  token: string;
  newLicense: DatabusLicenseFile;
  licenseID: number;
  licenseString: string;
  customerId: number;
  //currentUser: UserProfileModel;

  // for activation
  isActivate = false;
  states = STATES;

  public licenseFormModel: LicenseForm = new LicenseForm();

  public customerFormModel: FormGroup = this.formBuilder.group({
    company: ['', Validators.required],
    telephone: ['',  Validators.required],
    street: ['',  Validators.required] ,
    city: ['',  Validators.required],
    state: ['',  Validators.required]
  });

  get customerFormModelValue(): CustomerForm {
    return this.customerFormModel.value;
  }

  @ViewChild('customerModal', { static: false }) customerModal: ModalDirective;

  constructor(
    private app: ApplicationConfigService,
    private formBuilder: FormBuilder,
    private router: Router,    
    private dataBusService: DataBusService,
    private toasterService: ToastrService,
    public azureAuthService: AzureAuthService,
    public svc: DataBusService,
    public customerSvc: CustomerService,
    public databusTableService: DataBusTableService) {
      this.licenses = [];
      this.remoteData = this.databusTableService.remoteData;
      app.customerChanged$.subscribe(cid => {
        this.changeCustomer(this.app.customerId);
      });
  }

  ngOnInit(): void {
    this.databusTableService.get(null);
    
    
  }

  changeCustomer(customerId){
    console.log(customerId);
    if (this.azureAuthService.isGlobalViewer()){
      this.databusTableService.get(customerId);
    }
  }

  public promise: any;
  getLicensesForCustomer(): void {
    // todo - this is being called twice on load. - James
    // todo - need to pass user id, needs to be done before this is loaded.
    //this.treeGrid.isLoading = true;
    
    //this.promise = this.dataBusService.DataBusGetCustomerLicenses();
    /*this.dataBusService.DataBusGetCustomerLicenses()
      .subscribe(
        res => {
          this.licenses = res;
          console.log(this.licenses);
          this.remoteData.next(this.licenses);
          this.treeGrid.isLoading = false;
        },
        err => {
          console.error('ERROR: getLicensesForCustomer', err);
        }
      );*/
  }

  changeLicenseStatus() {
    if (this.licenses.length > 0) {
      for (const license of this.licenses) {
        const index = Number(license.licenseStatus);
        license.licenseStatus = LicenseStatus[LicenseStatus[index]];
      }
    }
  }

  openForm(license: DataBusLicense) {
    this.licenseFormModel.licenseId = license.licenseId;
    this.licenseForm.show();
  }

  openLicense(license: DataBusLicense) {
    this.router.navigate(["/databus/purchase/" + license.licenseId])
  }

  cancelActivate(){    
    //this.dialogActivate.close();
    this.licenseFormModel.serverToken = null;
  }

  closeForm() {
    this.isOpen = !this.isOpen;
  }

  submitServerToken() {
    // todo - Some of these args are nullable when perhaps they shouldnt be? - James
    const args: DataBusService.DataBusGenerateLicenseFileParams = {
      licenseId : this.licenseFormModel.licenseId,
      serverToken: this.licenseFormModel.serverToken
    };

    this.dataBusService.DataBusGenerateLicenseFile(args)
      .subscribe(
        res => {
          this.newLicense = res;
          //this.licenseID = res.licenseID,
          this.downloadLicense();

          this.getLicensesForCustomer();
          this.isOpen = false;
          this.toasterService.success("License File Generated","DataBus License");
        },
        err => {
          this.toasterService.error("Failed to generate license:" + err,"DataBus License");
          console.log(err);
        }
      );
  }

  downloadLicense() {
    //const data = JSON.stringify(this.newLicense);
    let lc = JSON.parse(this.newLicense.licenseString);
    let blob = new Blob(['\ufeff' + this.newLicense.licenseString], { type: 'application/json;charset=utf-8;' });
    let dwldLink = document.createElement("a");
    let url = URL.createObjectURL(blob);
    let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
    if (isSafariBrowser) {  //if Safari open in new window to save file with random filename.
        dwldLink.setAttribute("target", "_blank");
    }
    dwldLink.setAttribute("href", url);
    dwldLink.setAttribute("download", lc.customerName + "-" + lc.licenseName + ".lic");
    dwldLink.style.visibility = "hidden";
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
  }

  openLicenseForm(license: DataBusLicense) {
    this.licenseFormModel.licenseId = license.licenseId;  
    
    //this.dialogActivate.open();
    this.dataBusService.DataBusGetLicenseFile({customerId: this.app.customerId, licenseId: license.licenseId}).subscribe(l => {
      this.newLicense = l;
      this.downloadLicense();
    });
  }

  renewLicense(license: DataBusLicense) {
    if (confirm("Do you want to renew this license? A invoice will be generated and sent to your accounts department.")){
      this.dataBusService.DataBusRenewLicense({customerId: this.app.customerId, licenseId: license.licenseId}).subscribe(l => {
        this.toasterService.success("Renew request generated. A new invoice will be forwarded to your accounts department.", "License Renew Request Generated");
        this.databusTableService.get(this.app.customerId);
      });
    }
  }

  archiveLicense(license: DataBusLicense) {
    if (confirm("Are you sure you want to archive this license?")){
      this.dataBusService.DataBusArchiveLicense({customerId: this.app.customerId, licenseId: license.licenseId}).subscribe(l => {
        //license.licenseStatus = l.licenseStatus;
        //this.newLicense = l;
        this.toasterService.success("This license is no longer accessible", "License Archvied");
        this.databusTableService.get(this.app.customerId);
      });
    }
  }

  clearLicense(license: DataBusLicense) {
    this.dataBusService.DataBusApproveOrder({ orderId: license.licenseId, validTo:license.validTo } as DataBusService.DataBusApproveOrderParams).subscribe(l => {
      this.toasterService.success("License Cleared","License Cleared");
      license.licenseStatus = 'APPROVED';
    });
  }

  closeActivateForm() {
    this.isActivate = !this.isActivate;
  }

  copyInputMessage(inputElement) {}

  showModal() {
    this.customerModal.show();
  }

  closeModal() {
    this.customerModal.hide();
  }

  selectState(id: number, validFor: number) {
    this.customerFormModelValue.state = this.states[id].name;
    console.log(this.states[id].name);
  }



  public saveRow(event) {
    var id = event.rowID;
    /*const row = this.treeGrid.getRowByKey(id);
    if (row && row.rowData) {
      this.databusTableService.update(row.rowData as DataBusLicense).subscribe(
        res => {
          this.toasterService.success('Successfully Updated License', 'Update License');
        },
        err => {
          console.error("ERROR: saveRow");
          this.toasterService.error('Failed to Update License: ' + err.error.text, 'Update License');
        }
      );
    }*/
  }
}
